export default "__VITE_ASSET__Bvmo78xd__"